import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Brightness1 } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { TableComponent } from 'commons/components/Table';
import { InboundTaskItemStatusEnum } from 'commons/enums';
import { PRIMARY_GRAY } from 'commons/styles/colors';
import { IInboundTaskItem } from 'commons/types';
import {
  setInboundTaskcurrentReceiveItemIndex,
  setInboundTaskReceiveItem,
} from 'redux-stores/reducers/inboundTaskItemReducer';
import { AppDispatch } from 'redux-stores/store';
import { INBOUND_ROUTES } from 'routes/constants';

import { config } from '../config';
import S from '../InboundList.styles';

interface IInboundListTableProps {
  inboundTaskItems: IInboundTaskItem[];
}

export const InboundListTable: React.FC<IInboundListTableProps> = ({
  inboundTaskItems,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  return inboundTaskItems.map((item, idx) => {
    const receivedProgress = item.receive_actual.reduce(
      (sum, receiveActual) => sum + receiveActual.quantity,
      0,
    );

    const colorProgress =
      receivedProgress === 0
        ? S.colors.PROGRESS_ICON_COLOR[0]
        : receivedProgress !== item.quantity
        ? S.colors.PROGRESS_ICON_COLOR[2]
        : S.colors.PROGRESS_ICON_COLOR[1];
    const skuButtonText = receivedProgress === 0 ? 'RECEIVE SKU' : 'EDIT SKU';

    const getTableData = (): { bin: string; quantity: number }[] => {
      return item.receive_actual.map((receiveActual) => {
        return { bin: receiveActual.bin, quantity: receiveActual.quantity };
      });
    };

    const _navigateEditReceiveActual = (): void => {
      dispatch(setInboundTaskcurrentReceiveItemIndex(idx));
      dispatch(setInboundTaskReceiveItem(item));
      navigate(INBOUND_ROUTES.ITEM);
    };

    return (
      <Grid container sx={{ marginTop: '12px' }}>
        <S.SKUGridWrapper container>
          <S.SKUGrid
            className="bold"
            item
            xs={8}
            data-testid={`TextInboundListSKU-${idx + 1}`}
          >
            <Grid container item rowSpacing={1.25}>
              <Grid item container xs={12} columnSpacing={1.25}>
                <Grid item>
                  {item.sku_code}
                  <S.ProgressSpan data-testid={`TextInboundListQTY-${idx + 1}`}>
                    <Brightness1
                      style={{ fontSize: 11, color: colorProgress }}
                    />{' '}
                    {receivedProgress}/{item.quantity}
                  </S.ProgressSpan>
                </Grid>
                <Grid item>{item.foc && <S.FOCText>FOC</S.FOCText>}</Grid>
              </Grid>
              <Grid item xs={12}>
                {item.name}
              </Grid>
              <Grid item xs={12} sx={{ color: `${PRIMARY_GRAY}` }}>
                {item.uom}
              </Grid>
            </Grid>
          </S.SKUGrid>
          <S.ButtonGrid item xs={4}>
            <S.SecondaryButton
              onClick={(): void => _navigateEditReceiveActual()}
              data-testid={`BtnInboundListReceive-${idx + 1}`}
              disabled={item.status !== InboundTaskItemStatusEnum.RECEIVING}
            >
              {skuButtonText}
            </S.SecondaryButton>
          </S.ButtonGrid>
        </S.SKUGridWrapper>
        {item.receive_actual.length > 0 && (
          <S.TableInfoGrid item xs={12}>
            <TableComponent config={config} data={getTableData() || []} />
          </S.TableInfoGrid>
        )}
      </Grid>
    );
  });
};
